import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { Router } from '@angular/router';

/*Services */
import { DevicesService } from '@services/http/devices.service';
import { StateService } from '@services/state.service';
import { ScreenService } from '@services/screen.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { ObservableObjectsService } from '@services/http/observable-objects.service';

/*Models */
import { DeviceState } from '@models/device-state';
import { ObservableObject } from '@models/observable-object';
import { Device } from '@models/device';

/*Plugins */
import * as moment from 'moment';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'main-state-info',
  templateUrl: './main-state-info.component.html'
})

export class MainStateInfoComponent implements OnInit, OnDestroy {
  state: DeviceState;
  public isOpenCtrlMenu = false;
  public ifIgnOn: boolean;
  currentObservableObject: ObservableObject;
  public currentDevice: Device;
  firstDevice: Device = null;
  guardTimeText;
  colorObject;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private devicesService: DevicesService,
    private cachedDataService: CachedDataService,
    public stateService: StateService,
    protected router: Router,
    private observableObjectsService: ObservableObjectsService,
    public screenService: ScreenService) {

    this.stateService.stateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(state => {
        this.state = state;
        this.getTimeGuard();
        if (this.state.mainStates.autostart) {
          this.ifIgnOn = true;
        } else {
          this.ifIgnOn = false;
        }


        if (this.state.mainStates.guard) {
          this.colorObject = 'blue';
        } else {
          this.colorObject = 'white';
        }
      });
    this.stateService.observableObjectObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(object => {
        this.currentObservableObject = object;
        this.findFirstDevice();
      });

    this.stateService.currentDeviceSubject
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
        if (device) {
          this.findFirstDevice();
        }
      });

  }

  ngOnInit() {
    this.screenService.isStateHidden = false;
  }

  getObjectType() {
    if (this.currentObservableObject.extra) {
      return this.observableObjectsService.getObjectType(this.currentObservableObject.extra);
    } else {
      return 'default';
    }

  }
  getTimeGuard() {

    if (Math.abs(this.state.mainStates.guardTime)) {
      this.guardTimeText = this.getTime(Math.abs(this.state.mainStates.guardTime));
    }
  }
  getTime(value) {
    const currentDate = moment().format('DD MM YYYY');
    value = moment.unix(value);

    if (currentDate === value.format('DD MM YYYY')) {
      return value.format('HH:mm');
    } else {
      return (value.format('HH:mm') + '&nbsp;&nbsp;' + value.format('DD.MM.YY'));
    }

  }
  findFirstDevice() {

    this.firstDevice = null;
    if (this.currentObservableObject && this.currentObservableObject.devices.length > 1 && this.currentDevice) {
      if (this.currentDevice.deviceType === 'alarm') {
        this.currentObservableObject.devices.map(device => {
          if (device.deviceType === 'beacon') {
            if (this.firstDevice) {
              if (this.firstDevice.created > device.created) {
                this.firstDevice = device;
              }
            } else {
              this.firstDevice = device;
            }
          }
        });
      }
    }

    if (this.firstDevice) {

      this.devicesService.getState(this.firstDevice.id).subscribe(response => {
        if (this.firstDevice) {
          this.firstDevice['lastDate'] = this.getTime(response.additionalStates.time.value);
        }
      }, error => {
        console.log(error);
      });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/view/components/main-state-info/main-state-info.component.ts